import { from, Observable, throwError } from 'rxjs';
import ApiWrapper from '@/repositories/data/ApiWrapper';
import { flatMap } from 'rxjs/operators';

export default function unwrapApiWrapper<T>(observable: Observable<ApiWrapper<T>>): Observable<T | null> {
    return observable.pipe(flatMap((wrapper) => (wrapper.success ? from([wrapper.data]) : throwError(wrapper.data))));
}
